import React, { useMemo } from "react";
import { defineMessages } from "react-intl";
import { FilterGroupNew } from "../../../components/filter/FilterGroupNew.js";
import "moment-timezone";
import "../../../components/input/validation.js";
import "../../../components/input/DatePicker.js";
import "../../../components/input/DateRangePicker.js";
import "../../../components/input/StyledInput.js";
import "../../../components/input/FormInput.js";
import "../../../components/input/StyledFormInputHoc.js";
import { getYearDateRange } from "../../../utils/date.js";
import "../../../components/input/DateSinglePicker.localize.js";
import "../../../components/input/hooks.js";
import "@mui/material";
import { DateRangeFilter } from "../../../components/filter/dateRangeFilter/DateRangeFilter.js";
import "../../../components/filter/date-filter/DateFilter.js";
import { TextInputWithDropdownFilter } from "../../../components/filter/TextFilterWithDropdown.js";
import "../../../components/filter/MultiStepFilterDrawer.js";
import "../../../components/filter/dateRangeFilter/MultiStepFilterDatePicker.js";
import "../../../components/select/Select.js";
import { TextFilter } from "../../../components/filter/TextFilter.js";
import { ValueRangeFilter } from "../../../components/filter/valueRangeFilter/ValueRangeFilter.js";
import { HoursRangeFilter } from "../../../components/filter/valueRangeFilter/HoursRangeFilter.js";
import "../../../components/filter/dateRangeFilter/localized.js";
import { DateRangeHistoricalFilter } from "../../../components/filter/dateRangeFilter/DateRangeHistoricalFilter.js";
import "../../../components/filter/MultiStepFilterApplyButton.js";
import "../../../components/filter/MultiStepFilterInput.js";
import "../../../components/filter/MultiStepFilterHoc.js";
import "../../../components/chip/ChipRenderer.js";
import "../../../components/select/selectStyle.js";
import "../../../components/select/MultiSelectFooter.js";
import "../../../components/select/MultiSelect.js";
import "../../../components/select/MultiSelectItem.js";
import "../../../components/select/SelectArrowIcon.js";
import "../../../components/select/VirtualizedMultiSelectOptionList.js";
import "../../../components/select/SingleSelect.js";
import "../../../components/select/MultiSelectWithExclude.js";
import "../../../components/select/MultiSelectTextCounterWithTooltip.js";
import "../../../components/filter/PhoneFilter.js";
import "../../../localization/MessageLocalizer.js";
import { useLocale } from "../../../localization/hooks.js";
import "../../../localization/LocaleProvider.js";
import { sharedLocalization } from "../../../localization/sharedResources.js";
import { transactionHistoricalMaxYear, transactionHistoricalMinYear } from "../constants.js";
import { pendingCasesStatuses, closedCasesStatuses, retryTransactionStatuses } from "../types.js";
import { TransactionStatusFilter } from "./StatusFilter.js";
import TransactionTypeFilter from "./TypeFilter.js";
const localized = defineMessages({
  textFullFilter: {
    id: "TransactionFilterText_textFullFilter",
    defaultMessage: "All"
  },
  userIdFilter: {
    id: "TransactionFilterText_userIdFilter",
    defaultMessage: "User Id"
  },
  usernameFilter: {
    id: "TransactionFilterText_usernameFilter",
    defaultMessage: "Username"
  },
  withdrawalIdFilter: {
    id: "TransactionFilterText_withdrawalIdFilter",
    defaultMessage: "Withdrawal Id"
  },
  emailFilter: {
    id: "TransactionFilterText_emailFilter",
    defaultMessage: "Email"
  },
  labelFilter: {
    id: "TransactionFilterText_labelFilter",
    defaultMessage: "Label"
  },
  transactionIdFilter: {
    id: "TransactionFilterText_transactionIdFilter",
    defaultMessage: "Transaction Id"
  },
  textFullFilterPlaceholder: {
    id: "TransactionFilterText_textFullPlaceholder",
    defaultMessage: "For example, 123"
  },
  withdrawalTextFullFilterPlaceholder: {
    id: "TransactionFilterText_textFullFilterPlaceholder",
    defaultMessage: "Search in Withdrawal Processing Workspace"
  },
  userIdFilterPlaceholder: {
    id: "TransactionFilterText_userIdFilterPlaceholder",
    defaultMessage: "123"
  },
  usernameFilterPlaceholder: {
    id: "TransactionFilterText_usernameFilterPlaceholder",
    defaultMessage: "For example, Antonio"
  },
  withdrawalIdFilterPlaceholder: {
    id: "TransactionFilterText_withdrawalIdFilterPlaceholder",
    defaultMessage: "bbe7e0d8-8630-443e-b69a-7100c9dfb8b5"
  },
  transactionIdFilterPlaceholder: {
    id: "TransactionFilterText_transactionIdFilterPlaceholder",
    defaultMessage: "bbe7e0d8-8630-443e-b69a-7100c9dfb8b5"
  },
  emailFilterPlaceholder: {
    id: "TransactionFilterText_emailFilterPlaceholder",
    defaultMessage: "For example, antonio@xyz.com"
  },
  labelFilterPlaceholder: {
    id: "TransactionFilterText_labelFilterPlaceholder",
    defaultMessage: "123"
  },
  transactionStatusFilter: {
    id: "TransactionFilterStatuses_transactionStatusFilter",
    defaultMessage: "Status"
  },
  withdrawalStatusFilter: {
    id: "TransactionFilterStatuses_withdrawalStatusFilter",
    defaultMessage: "Withdrawal Status"
  },
  amountFilter: {
    id: "TransactionFilterAmount_filterAmount",
    defaultMessage: "Amount"
  },
  openDurationFilter: {
    id: "DurationRangePicker_filterOpenDuration",
    defaultMessage: "Open Duration"
  },
  paymentMethodFilter: {
    id: "DurationRangePicker_paymentMethodFilter",
    defaultMessage: "Method"
  }
});
function TransactionFilters({ model, onChange, availableFilters, minAmount }) {
  const { locale } = useLocale();
  function getTextFilterPlaceholder(option) {
    const placeholderMapper = {
      uid_un_tid_em: localized.withdrawalTextFullFilterPlaceholder,
      uid: localized.userIdFilterPlaceholder,
      username: localized.usernameFilterPlaceholder,
      transactionId: localized.transactionIdFilterPlaceholder,
      withdrawalId: localized.withdrawalIdFilterPlaceholder,
      email: localized.emailFilterPlaceholder
    };
    return placeholderMapper[option] ?? localized.textFullFilterPlaceholder;
  }
  const historicalDateRange = useMemo(
    () => ({
      from: getYearDateRange(transactionHistoricalMinYear).from,
      to: getYearDateRange(transactionHistoricalMaxYear).to
    }),
    []
  );
  const recentDateRange = useMemo(
    () => ({
      from: getYearDateRange(transactionHistoricalMaxYear + 1).from
    }),
    []
  );
  const filters = [
    {
      filterName: "uidUsernameTransactionIdEmail",
      modelField: "text",
      component: (props) => /* @__PURE__ */ React.createElement(
        TextInputWithDropdownFilter,
        {
          options: [
            { label: sharedLocalization.textFullFilter, value: "uid_un_tid_em" },
            { label: localized.userIdFilter, value: "uid" },
            { label: localized.usernameFilter, value: "username" },
            { label: localized.emailFilter, value: "email" }
          ],
          getInputPlaceholder: getTextFilterPlaceholder,
          width: "full",
          ...props
        }
      ),
      collapseOnMobile: false
    },
    {
      filterName: "uid",
      modelField: "text",
      component: (props) => /* @__PURE__ */ React.createElement(
        TextInputWithDropdownFilter,
        {
          options: [{ label: localized.userIdFilter, value: "uid" }],
          inputPlaceholder: getTextFilterPlaceholder(props?.value?.option),
          width: "full",
          ...props
        }
      ),
      collapseOnMobile: false
    },
    {
      filterName: "creationDate",
      modelField: "date",
      component: (props) => /* @__PURE__ */ React.createElement(DateRangeFilter, { ...props, locale }),
      collapseOnMobile: false
    },
    {
      filterName: "pendingStatuses",
      modelField: "status",
      component: (props) => /* @__PURE__ */ React.createElement(TransactionStatusFilter, { label: localized.withdrawalStatusFilter, options: pendingCasesStatuses, ...props }),
      collapseOnMobile: false
    },
    {
      filterName: "closedStatuses",
      modelField: "status",
      component: (props) => /* @__PURE__ */ React.createElement(TransactionStatusFilter, { label: localized.withdrawalStatusFilter, options: closedCasesStatuses, ...props }),
      collapseOnMobile: false
    },
    {
      filterName: "failedStatuses",
      modelField: "status",
      component: (props) => /* @__PURE__ */ React.createElement(TransactionStatusFilter, { label: localized.transactionStatusFilter, options: retryTransactionStatuses, ...props }),
      collapseOnMobile: false
    },
    {
      filterName: "status",
      modelField: "status",
      component: (props) => /* @__PURE__ */ React.createElement(
        TransactionStatusFilter,
        {
          label: localized.transactionStatusFilter,
          options: [...pendingCasesStatuses, ...closedCasesStatuses],
          withReasons: false,
          ...props
        }
      ),
      collapseOnMobile: false
    },
    {
      filterName: "amount",
      modelField: "amount",
      component: (props) => {
        return /* @__PURE__ */ React.createElement(ValueRangeFilter, { ...props, label: localized.amountFilter, min: minAmount, width: "fixed" });
      },
      collapseOnMobile: false
    },
    {
      filterName: "duration",
      modelField: "date",
      component: (props) => {
        return /* @__PURE__ */ React.createElement(HoursRangeFilter, { ...props, width: "fixed", label: localized.openDurationFilter });
      },
      collapseOnMobile: false
    },
    {
      filterName: "paymentMethod",
      modelField: "paymentMethod",
      component: (props) => /* @__PURE__ */ React.createElement(TextFilter, { width: "full", inputPlaceholder: localized.paymentMethodFilter, ...props }),
      collapseOnMobile: false
    },
    {
      filterName: "transactionHistoryTypes",
      modelField: "types",
      component: (props) => /* @__PURE__ */ React.createElement(TransactionTypeFilter, { ...props }),
      collapseOnMobile: false
    },
    {
      filterName: "historicalCreationDate",
      modelField: "date",
      component: (props) => /* @__PURE__ */ React.createElement(
        DateRangeHistoricalFilter,
        {
          ...props,
          locale,
          entities: "transactions",
          historicalDateRange,
          recentDateRange
        }
      ),
      collapseOnMobile: false
    }
  ];
  return /* @__PURE__ */ React.createElement(
    FilterGroupNew,
    {
      model,
      onChange,
      mode: "update-on-change",
      allFilters: filters,
      availableFilters
    }
  );
}
export {
  TransactionFilters
};
//# sourceMappingURL=Filters.js.map
